module.exports = "<div class=\"input-group\">\n  <input type=\"text\" class=\"form-control\" placeholder=\"Suche...\" (keyup)=\"searchTermChange()\" [(ngModel)]=\"searchTerm\">\n  <span class=\"input-group-addon\"><span class=\"glyphicon glyphicon-search\"></span></span>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /usr/src/app/src/app/shared/search-bar/search-bar.component.html
// module id = ../../../../../src/app/shared/search-bar/search-bar.component.html
// module chunks = main